const createFocusTrap = require('focus-trap');


export default function rlxOpeningTimes() {
    const $WRAPPER = $('.js-rlx-v7-opening-times');
    const $BUTTON = $('.js-rlx-v7-opening-times-button');
    const $LAYER = $('.js-rlx-v7-opening-times-layer');
    const $LAYER_CLOSE = $LAYER.find('.layer__close');
    const IS_HIDDEN = '_d-none';
    const IS_ACTIVE = 'is--active';

    const focusTrapLayer = createFocusTrap('.js-rlx-v7-opening-times .layer__list', {
        clickOutsideDeactivates: true,
        onActivate() {
            $BUTTON.attr('aria-expanded', true);
            $LAYER.attr('aria-hidden', false);
            $BUTTON.addClass(IS_ACTIVE);
        },
        onDeactivate() {
            $BUTTON.attr('aria-expanded', false);
            $LAYER.attr('aria-hidden', true);
            $BUTTON.removeClass(IS_ACTIVE);
            $LAYER.addClass(IS_HIDDEN);
        },
    });

    const showLayer = () => {
        $LAYER.removeClass(IS_HIDDEN);
        focusTrapLayer.activate();
    };

    const hideLayer = () => {
        $LAYER.addClass(IS_HIDDEN);
        focusTrapLayer.deactivate();
    };

    const toggleLayer = () => {
        if ($LAYER.hasClass(IS_HIDDEN)) {
            showLayer();
        } else {
            hideLayer();
        }
    };

    const handleClick = () => {
        $BUTTON.on('click', () => {
            toggleLayer();
        });

        $LAYER_CLOSE.on('click', () => {
            hideLayer();
        });
    };

    if ($WRAPPER.length > 0) {
        handleClick();
    }
}
